module.exports = __webpack_public_path__ + "static/media/avatar.c3c5aa57.jpg";